<form [formGroup]="bankAccountForm" class="w-full">
  <h3>Account information</h3>

  <app-shared-input
    [control]="bankAccountForm.controls['routingNumber']"
    label="Routing number"
    dataAutoId="routing-number-input"
    [maxLength]="9"
    [isShowHide]="true">
    <small extra-content class="mt-1 text-slate-600">
      Routing number (9 digits, no spaces)
    </small>
    <small extra-error *ngIf="bankAccountForm.controls['routingNumber'].errors?.['invalidRoutingChecksum']" class="mt-1 text-rose-600">
      Routing number is not valid.
    </small>
  </app-shared-input>

  <app-shared-input
    [control]="bankAccountForm.controls['accountNumber']"
    label="Account number"
    dataAutoId="account-number-input"
    [isShowHide]="true"
    [maxLength]="17">
    <small extra-content class="mt-1 text-slate-600">
      Account number (17 digits, no spaces)
    </small>
    <small extra-error *ngIf="bankAccountForm.controls['accountNumber'].errors?.['maxlength']" class="mt-1 text-rose-600">
     Account number is not valid.
    </small>
  </app-shared-input>

  <div class="p-fieldset field pt-4">
    <label id="accountTypeLabel" class="font-medium">Account type</label>
    <div *ngIf="bankAccountForm.controls['accountTypes'].errors?.['required']" class="required">
      <span class="bg-slate-100">Required</span>
    </div>
    <div *ngIf="bankAccountForm.controls['accountTypes'].touched && bankAccountForm.controls['accountTypes'].errors?.['required']" class="required text-orange-900">
      <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
    </div>
    <p-select aria-labelledby="accountTypeLabel" formControlName="accountTypes" placeholder="Select an Account Type" class="flex w-full" [options]="accountTypes" [showClear]="true" data-auto-id="account-type-select"></p-select>
    <div *ngIf="bankAccountForm.controls['accountTypes'].touched">
      <small *ngIf="bankAccountForm.controls['accountTypes'].errors?.['required']" class="mt-1 text-rose-600">
        Please select an account type.
      </small>
    </div>
  </div>
</form>
